class PointService {
  static base = '/points';

  static find = (id) => `${this.base}/${id}`;
}

export default PointService;
